import { Instagram, ArrowUpRight } from "lucide-react";
import { useT } from "../lib/i18n";

export default function Footer() {
  const { t } = useT();
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  const navItems = [
    ["hero", "nav.home"],
    ["about", "nav.about"],
    ["trainings", "nav.trainings"],
    ["schedule", "nav.schedule"],
    ["membership", "nav.membership"],
    ["pt", "nav.pt"],
    ["contact", "nav.contact"],
  ];
  return (
    <footer className="bg-[#0A0A0A] text-[#E8E4DF] grain grain-dark relative" data-testid="site-footer">
      <div className="px-6 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <div className="chip text-[#A3A3A3] mb-6">— JOH. Boxing / Amsterdam</div>
            <p className="font-display text-4xl md:text-6xl uppercase leading-[0.9] max-w-xl">
              {t("footer.line")}<br /><span className="font-serif-italic normal-case text-[#DDD6CB] tracking-tight">{t("footer.tag")}</span>
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <button onClick={() => scrollTo("trial")} className="btn-light" data-testid="footer-book-trial-btn">
                {t("nav.book")} <ArrowUpRight size={14} />
              </button>
              <a
                href="https://wa.me/31626923741"
                target="_blank"
                rel="noreferrer"
                className="btn-ghost text-[#E8E4DF] border-[#E8E4DF] hover:bg-[#E8E4DF] hover:text-[#0A0A0A]"
                data-testid="footer-whatsapp-link"
              >
                Whatsapp <ArrowUpRight size={14} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="chip text-[#A3A3A3] mb-4">{t("footer.nav")}</div>
            <ul className="space-y-2">
              {navItems.map(([k, label]) => (
                <li key={k}>
                  <button
                    onClick={() => scrollTo(k)}
                    className="text-[#DDD6CB] hover:text-white transition-colors"
                    data-testid={`footer-nav-${k}`}
                  >
                    {t(label)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="chip text-[#A3A3A3] mb-4">{t("footer.legal")}</div>
            <ul className="space-y-2 text-[#DDD6CB]">
              <li><a href="/voorwaarden" className="accent-hover" data-testid="footer-terms-link">{t("footer.terms")}</a></li>
              <li><a href="/privacy" className="accent-hover" data-testid="footer-privacy-link">{t("footer.privacy")}</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="chip text-[#A3A3A3] mb-4">{t("footer.follow")}</div>
            <ul className="space-y-2">
              <li><a href="https://instagram.com/johboxing" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#DDD6CB] accent-hover" data-testid="footer-instagram-link"><Instagram size={14}/> @johboxing</a></li>
              <li><a href="mailto:info@johboxing.com" className="text-[#DDD6CB] accent-hover" data-testid="footer-email-link">info@johboxing.com</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Giant JOH mark */}
      <div className="relative overflow-hidden line-t line-dark">
        <div className="font-logo text-[26vw] leading-[0.8] text-[#E8E4DF] px-6 md:px-10 py-6 select-none">
          JOH.
        </div>
      </div>

      <div className="px-6 md:px-10 py-6 line-t line-dark flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="chip text-[#A3A3A3]">{t("footer.copy")}</div>
        <div className="chip text-[#A3A3A3]">{t("footer.made")}</div>
      </div>
    </footer>
  );
}
